/**
  * @class meleActorRoi
  * @description
  *
  * # Purpose
  * Implements `<mele-actor-roi>` custom web element for showing radar region of interest from mmRadarConfig in <mele-channel>
  */

import meleActor from 'meleActor'

const PROPERTIES = _.extend({}, {
  state: { description: 'current state of the radar', type: 'string', readonly: true },
}, meleActor._properties)

export default class meleActorRoi extends meleActor {
  async init() {
    this.elSvg = this.appendChildren({ tag: 'svg', width: 1920, height: 1080 })
    super.init()
  } // init

  message({ action, params }) {
    if(action=='mmRadar') {
      this.state = params.state
    }else if(action=='mmRadarConfig') {
      if(!params.roi) return // avoids errors when radar not connected
      this.elSvg.setAttribute('viewBox', `0 0 ${params.width} ${params.height}`)
      this.elSvg.innerHTML = `<rect x="${params.roi.x}" y="${params.roi.y}" width="${params.roi.width}" height="${params.roi.height}" />`
    }
  } // message
} // class meleActorRoi

meleActorRoi._properties = PROPERTIES
meleActorRoi.observedAttributes = _.keys(PROPERTIES)
window.customElements.define('mele-actor-roi', meleActorRoi)
